import Api from "./axiosVersion1";

export const getProducts = async () => {
  return Api.get(`/get_products`);
};

export const renewSubscription = async (data) => {
  const formData = new URLSearchParams();
  formData.append('price_id', data.price_id);
  formData.append('redirect_url', data.redirect_url);

  return Api.post(`/renew-subscription`, formData, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
};

